// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"RecoverPasswordFormPassword_card_footer__38rQy","card_content":"RecoverPasswordFormPassword_card_content__3ECSG"};